export const DESIGN_DETAIL_LAYOUT_CLASSLIST = [
  'design-detail-layout',
  'gl-overflow-hidden',
  'gl-m-0',
];
